import { render, staticRenderFns } from "./InstitucionesAsesor.vue?vue&type=template&id=2a51144e"
import script from "./InstitucionesAsesor.vue?vue&type=script&lang=js"
export * from "./InstitucionesAsesor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports